import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Grid, RadioButton, RadioGroup } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import BetongIcon from '../../../../../../../assets/icons/materials/concrete.svg?react';
import BetongInvertedIcon from '../../../../../../../assets/icons/materials/concrete-inverted.svg?react';
import MurIcon from '../../../../../../../assets/icons/materials/bricks.svg?react';
import MurInvertedIcon from '../../../../../../../assets/icons/materials/bricks-inverted.svg?react';
import StalIcon from '../../../../../../../assets/icons/materials/steel.svg?react';
import StalInvertedIcon from '../../../../../../../assets/icons/materials/steel-inverted.svg?react';
import TreIcon from '../../../../../../../assets/icons/materials/wood.svg?react';
import TreInvertedIcon from '../../../../../../../assets/icons/materials/wood-inverted.svg?react';
import { Konstruksjonsmateriale } from '../../../../../utils/registerEnums';
import { AboutFormData } from '../../types';

interface ConstructionMaterialRadiogroupProps {
  control: Control<AboutFormData>;
}

const options = [
  {
    value: Konstruksjonsmateriale.Betong,
    icon: BetongIcon,
    invertedIcon: BetongInvertedIcon
  },
  {
    value: Konstruksjonsmateriale.Tre,
    icon: TreIcon,
    invertedIcon: TreInvertedIcon
  },
  {
    value: Konstruksjonsmateriale.MurTeglstein,
    icon: MurIcon,
    invertedIcon: MurInvertedIcon
  },
  {
    value: Konstruksjonsmateriale.Stal,
    icon: StalIcon,
    invertedIcon: StalInvertedIcon
  }
];

export const MaterialRadioGroup: FC<ConstructionMaterialRadiogroupProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="bygginfo.material"
      control={control}
      rules={{
        required: t('register.bygningsdetaljer.konstruksjonsmateriale.error')
      }}
      render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => {
        return (
          <RadioGroup
            row
            required
            label={t('register.bygningsdetaljer.konstruksjonsmateriale.label')}
            description={t('register.bygningsdetaljer.konstruksjonsmateriale.information')}
            error={!!error}
            helperText={error && t(`${error.message}`)}
            value={value ?? null}
            onChange={(_, val) => onChange(val)}
            {...rest}
          >
            <Grid container spacing={2}>
              {options.map(({ value, icon: Icon, invertedIcon: InvertedIcon }) => {
                return (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={value}>
                    <RadioButton
                      key={value}
                      value={value}
                      label={t(`register.bygningsdetaljer.konstruksjonsmateriale.option.${value}`)}
                      icon={<Icon />}
                      invertedIcon={<InvertedIcon />}
                      width="fullWidth"
                    />
                  </Grid>
                );
              })}
            </Grid>
          </RadioGroup>
        );
      }}
    />
  );
};
